(() => {
  'use strict';
  const config = window.Pajareva || {};
  const route = config.routes || {};
  const cartPath = route.cart || '/cart';
  const iso = config.currency || 'MXN';
  const fmt = new Intl.NumberFormat('es-MX', {style: 'currency', currency: iso, currencyDisplay: 'narrowSymbol', minimumFractionDigits: 2});
  const money = cents => { const s = fmt.format((Number(cents) || 0) / 100); return s.includes('$') ? s.replace(/\$\s?/, '$ ') + ' ' + iso : s; };
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const icon = name => {
    const paths = {
      tag: '<svg class="pj-ico" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M21.4 11.6 12.4 2.6A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7c0 .5.2 1 .6 1.4l9 9a2 2 0 0 0 2.8 0l7-7a2 2 0 0 0 0-2.8ZM6.5 8A1.5 1.5 0 1 1 8 6.5 1.5 1.5 0 0 1 6.5 8Z"/></svg>',
      trash: '<svg class="pj-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    };
    return paths[name] || '';
  };

  /* ---------- Carrito (cajón) ---------- */
  const drawer = document.getElementById('pj-cart-drawer');
  let lastOpener = null;
  let busy = false;
  let compareMap = {};
  const mapEl = document.querySelector('[data-cart-compare-map]');
  if (mapEl) { try { compareMap = JSON.parse(mapEl.textContent); } catch (e) { compareMap = {}; } }
  /* Máximo por pedido (OFFRE.txt) : 10 lámparas. */
  const MAX_QTY = Number(config.maxQty) || 10;
  const MAX_MSG = 'Máximo ' + MAX_QTY + ' lámparas por pedido.';
  let cartChanged = false;
  const showError = message => { const box = document.querySelector('[data-cart-error]'); if (box) { box.textContent = message; box.hidden = false; } };
  const hideError = () => { const box = document.querySelector('[data-cart-error]'); if (box) box.hidden = true; };

  const TIMER_KEY = 'pj-cart-until';
  const TIMER_SPAN = 5 * 60 * 1000;
  const timerTick = () => {
    document.querySelectorAll('[data-cart-timer]').forEach(bar => {
      if (bar.hidden) return;
      let until = 0;
      try { until = Number(localStorage.getItem(TIMER_KEY)) || 0; } catch (e) {}
      if (until < Date.now()) { until = Date.now() + TIMER_SPAN; try { localStorage.setItem(TIMER_KEY, String(until)); } catch (e) {} }
      const s = Math.max(0, Math.round((until - Date.now()) / 1000));
      const clock = bar.querySelector('[data-cart-timer-clock]');
      if (clock) clock.textContent = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
    });
  };
  const timerShow = hasItems => {
    const bar = drawer && drawer.querySelector('[data-cart-timer]');
    if (bar) bar.hidden = !hasItems;
    if (!hasItems) { try { localStorage.removeItem(TIMER_KEY); } catch (e) {} }
    timerTick();
  };
  setInterval(timerTick, 1000);
  timerTick();

  const paintCart = cart => {
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    const body = document.querySelector('[data-cart-body]');
    const footer = document.querySelector('[data-cart-footer]');
    if (!body || !footer) return;
    timerShow(cart.item_count > 0);
    const cmpRow = footer.querySelector('[data-cart-compare-row]');
    const saveRow = footer.querySelector('[data-cart-save-row]');
    const maxNote = footer.querySelector('[data-cart-max]');
    if (!cart.item_count) {
      body.innerHTML = '<div class="pj-drawer-empty"><p>Tu carrito está vacío.</p><a class="pj-btn" href="' + esc(config.productUrl || '/products/lampara-pajaro') + '">Ver la lámpara pájaro</a></div>';
      /* Panier vide : on efface les montants et on masque tout le pied (total, bouton de paiement). */
      footer.querySelectorAll('[data-cart-compare],[data-cart-save],[data-cart-total]').forEach(el => { el.textContent = ''; });
      if (cmpRow) cmpRow.hidden = true;
      if (saveRow) saveRow.hidden = true;
      footer.hidden = true;
      return;
    }
    footer.hidden = false;
    if (maxNote) { maxNote.textContent = MAX_MSG; maxNote.hidden = cart.item_count < MAX_QTY; }
    const full = cart.item_count >= MAX_QTY;
    let reference = 0;
    body.innerHTML = cart.items.map(item => {
      const unitRef = Math.max(Number(compareMap[item.variant_id]) || 0, item.original_price || 0);
      const lineRef = unitRef * item.quantity;
      reference += lineRef;
      let image = (item.featured_image && item.featured_image.url) || item.image;
      if (image && /cdn\.shopify\.com|\/cdn\/shop\//.test(image) && !/[?&]width=/.test(image)) image += (image.includes('?') ? '&' : '?') + 'width=160';
      const allocations = (item.line_level_discount_allocations || []).map(a => a.discount_application && a.discount_application.title).filter(Boolean);
      const titles = allocations.length ? allocations : (item.discounts || []).map(d => d.title).filter(Boolean);
      const tags = titles.map(t => '<p class="pj-line-tag">' + icon('tag') + esc(t) + '</p>').join('');
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="pj-line-tag">' + esc(item.variant_title) + '</p>' : '';
      return '<article class="pj-line">' +
        (image ? '<a href="' + esc(item.url) + '"><img src="' + esc(image) + '" alt="' + esc(item.product_title) + '" width="76" height="76" loading="lazy"></a>' : '<span></span>') +
        '<div class="pj-line-main"><a class="pj-line-title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' + variant + tags +
        '<div class="pj-line-actions"><div class="pj-qty"><button type="button" data-cart-change="' + esc(item.key) + '" data-quantity="' + Math.max(0, item.quantity - 1) + '" aria-label="Quitar una">−</button>' +
        '<input value="' + item.quantity + '" aria-label="Cantidad" type="number" inputmode="numeric" min="0" max="' + (MAX_QTY - (cart.item_count - item.quantity)) + '" data-cart-input="' + esc(item.key) + '" data-current="' + item.quantity + '">' +
        '<button type="button" data-cart-change="' + esc(item.key) + '" data-quantity="' + (item.quantity + 1) + '" aria-label="Agregar una"' + (full ? ' disabled title="' + esc(MAX_MSG) + '"' : '') + '>+</button></div>' +
        '<button class="pj-trash" type="button" data-cart-change="' + esc(item.key) + '" data-quantity="0" aria-label="Eliminar">' + icon('trash') + '</button></div></div>' +
        '<div class="pj-line-prices">' + (lineRef > item.final_line_price ? '<s>' + money(lineRef) + '</s>' : '') + '<b>' + money(item.final_line_price) + '</b></div></article>';
    }).join('');
    const save = reference - cart.total_price;
    if (cmpRow) cmpRow.hidden = !(save > 0);
    if (saveRow) saveRow.hidden = !(save > 0);
    if (save > 0) { footer.querySelector('[data-cart-compare]').textContent = money(reference); footer.querySelector('[data-cart-save]').textContent = '−' + money(save); }
    footer.querySelector('[data-cart-total]').textContent = money(cart.total_price);
  };
  const loadCart = async () => {
    hideError();
    const response = await fetch(cartPath + '.js', {headers: {'Accept': 'application/json'}, credentials: 'same-origin'});
    if (!response.ok) throw new Error('No pudimos cargar tu carrito. Inténtalo de nuevo.');
    let cart = await response.json();
    cart = await enforceMax(cart);
    paintCart(cart);
    return cart;
  };
  /* Si un carrito trae más de MAX_QTY (enlace externo, carrito antiguo), se reduce desde la última línea. */
  const enforceMax = async cart => {
    if (!cart || cart.item_count <= MAX_QTY) return cart;
    let excess = cart.item_count - MAX_QTY;
    const updates = {};
    for (const item of [...cart.items].reverse()) {
      if (excess <= 0) break;
      const cut = Math.min(excess, item.quantity);
      updates[item.key] = item.quantity - cut;
      excess -= cut;
    }
    const response = await fetch((route.cart || cartPath) + '/update.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({updates})});
    if (!response.ok) return cart;
    const next = await response.json();
    next.__clamped = true;
    cartChanged = true;
    return next;
  };
  const openCart = async opener => {
    lastOpener = opener || document.activeElement;
    if (!drawer || !drawer.showModal) { location.href = cartPath; return; }
    if (!drawer.open) drawer.showModal();
    document.documentElement.style.overflow = 'hidden';
    try { await loadCart(); } catch (error) { showError(error.message); }
  };
  document.querySelectorAll('[data-cart-open]').forEach(btn => btn.addEventListener('click', event => { event.preventDefault(); openCart(btn); }));
  if (drawer) {
    drawer.querySelector('[data-cart-close]')?.addEventListener('click', () => drawer.close());
    drawer.addEventListener('close', () => {
      document.documentElement.style.overflow = '';
      if (cartChanged && document.querySelector('.pj-cart-page')) { location.reload(); return; }
      if (lastOpener && lastOpener.focus) lastOpener.focus();
    });
    drawer.addEventListener('click', event => {
      if (event.target === drawer) { const box = drawer.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) drawer.close(); }
      const btn = event.target.closest('[data-cart-change]');
      if (btn) changeCart(btn.dataset.cartChange, Number(btn.dataset.quantity));
    });
    drawer.addEventListener('change', event => {
      const input = event.target.closest('[data-cart-input]');
      if (!input) return;
      const n = Number(input.value.trim());
      const limit = Number(input.max) || MAX_QTY;
      if (input.value.trim() !== '' && Number.isInteger(n) && n >= 0) {
        if (n > limit) { input.value = limit; changeCart(input.dataset.cartInput, limit); }
        else changeCart(input.dataset.cartInput, n);
      } else input.value = input.dataset.current;
    });
  }
  const changeCart = async (key, quantity) => {
    if (!key || !Number.isInteger(quantity) || quantity < 0 || quantity > MAX_QTY || busy) return;
    busy = true; hideError();
    try {
      const response = await fetch((route.change || cartPath + '/change') + '.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({id: key, quantity})});
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'No pudimos cambiar la cantidad. Inténtalo de nuevo.');
      cartChanged = true;
      const cart = await enforceMax(data);
      paintCart(cart);
    } catch (error) { showError(error.message); } finally { busy = false; }
  };

  /* Página del carrito: si llega con más de MAX_QTY, se reduce y se recarga. */
  const cartPage = document.querySelector('.pj-cart-page[data-cart-qty]');
  if (cartPage && Number(cartPage.dataset.cartQty) > MAX_QTY) {
    fetch(cartPath + '.js', {headers: {'Accept': 'application/json'}, credentials: 'same-origin'}).then(r => r.json()).then(enforceMax).then(c => { if (c && c.__clamped) location.reload(); }).catch(() => {});
  }

  /* ---------- Ficha: acabado, lotes con un acabado por lámpara, agregar al carrito, barra fija ---------- */
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const gallery = document.querySelector('[data-gallery]');
  const showMedia = mediaId => {
    if (!gallery || !mediaId) return;
    const slides = [...gallery.querySelectorAll('[data-gallery-track] > *')];
    const i = slides.findIndex(s => s.dataset.mediaId === String(mediaId));
    if (i >= 0 && gallery.__go) gallery.__go(i);
  };
  const form = document.querySelector('[data-buy-form]');
  if (form) {
    const tiers = [...form.querySelectorAll('.pj-tier')];
    const button = form.querySelector('[data-add-button]');
    const error = form.querySelector('[data-form-error]');
    const mainId = form.querySelector('[data-main-id]');
    const finishName = form.querySelector('[data-finish-name]');
    const finishBtns = [...form.querySelectorAll('[data-finish]')];
    const sticky = document.querySelector('[data-sticky]');
    const stickyLabel = sticky && sticky.querySelector('[data-sticky-label]');
    const stickyPrice = sticky && sticky.querySelector('[data-sticky-price]');
    const stickyBtn = sticky && sticky.querySelector('[data-sticky-add]');
    const stickySave = sticky && sticky.querySelector('[data-sticky-save]');
    const stickySaveWrap = sticky && sticky.querySelector('[data-sticky-save-wrap]');
    const available = form.dataset.available === 'true';
    let finish = Number(form.dataset.variantId);
    let adding = false;
    const current = () => form.querySelector('input[name="quantity"]:checked');
    const sync = () => {
      tiers.forEach(t => t.classList.toggle('is-selected', !!t.querySelector('input:checked')));
      const input = current();
      if (input && stickyLabel) {
        stickyLabel.textContent = input.dataset.label;
        const p = input.closest('.pj-tier').querySelector('[data-tier-price]');
        if (p && stickyPrice) stickyPrice.textContent = p.textContent;
        /* % de ahorro DEL LOTE elegido (no el de 1 lámpara). */
        const pct = Number(input.dataset.save) || 0;
        if (stickySave) stickySave.textContent = '¡Ahorra ' + pct + '%!';
        if (stickySaveWrap) stickySaveWrap.style.display = pct > 0 ? '' : 'none';
      }
    };
    /* Selector personalizado de cada lámpara (imagen + nombre, nunca el menú nativo). */
    const closePicks = except => form.querySelectorAll('[data-pick]').forEach(pick => {
      if (pick === except) return;
      const list = pick.querySelector('[data-pick-list]'); const btn = pick.querySelector('[data-pick-btn]');
      if (list) list.hidden = true; if (btn) btn.setAttribute('aria-expanded', 'false');
    });
    const setPick = (pick, opt) => {
      if (!pick || !opt) return;
      pick.dataset.value = opt.dataset.option;
      pick.querySelectorAll('[data-option]').forEach(o => o.setAttribute('aria-selected', String(o === opt)));
      const name = pick.querySelector('[data-pick-name]'); if (name) name.textContent = opt.dataset.name;
      const img = pick.querySelector('[data-pick-img]'); if (img && opt.dataset.img) img.src = opt.dataset.img;
    };
    const setFinish = (btn, move) => {
      if (!btn || btn.disabled) return;
      finish = Number(btn.dataset.finish);
      if (mainId) mainId.value = String(finish);
      finishBtns.forEach(b => b.setAttribute('aria-pressed', String(b === btn)));
      if (finishName) finishName.textContent = btn.dataset.name;
      form.querySelectorAll('[data-pick]').forEach(pick => setPick(pick, pick.querySelector('[data-option="' + finish + '"]')));
      if (move) showMedia(btn.dataset.mediaId);
    };
    finishBtns.forEach(btn => btn.addEventListener('click', () => setFinish(btn, true)));
    form.addEventListener('click', event => {
      const btn = event.target.closest('[data-pick-btn]');
      if (btn) {
        event.preventDefault();
        const pick = btn.closest('[data-pick]'); const list = pick.querySelector('[data-pick-list]');
        const open = list.hidden;
        closePicks(pick);
        list.hidden = !open; btn.setAttribute('aria-expanded', String(open));
        if (open) (list.querySelector('[aria-selected="true"]') || list.querySelector('[data-option]'))?.focus();
        return;
      }
      const opt = event.target.closest('[data-option]');
      if (opt) {
        event.preventDefault();
        const pick = opt.closest('[data-pick]');
        setPick(pick, opt);
        closePicks();
        pick.querySelector('[data-pick-btn]')?.focus();
        showMedia(opt.dataset.mediaId);
      }
    });
    document.addEventListener('click', event => { if (!event.target.closest('[data-pick]')) closePicks(); });
    form.addEventListener('keydown', event => {
      const list = event.target.closest('[data-pick-list]');
      if (event.key === 'Escape') { const pick = event.target.closest('[data-pick]'); if (pick) { closePicks(); pick.querySelector('[data-pick-btn]')?.focus(); } return; }
      if (!list || (event.key !== 'ArrowDown' && event.key !== 'ArrowUp')) return;
      event.preventDefault();
      const opts = [...list.querySelectorAll('[data-option]:not([disabled])')];
      const i = opts.indexOf(document.activeElement);
      const next = opts[(i + (event.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length];
      if (next) next.focus();
    });
    form.addEventListener('change', sync);
    sync();
    document.querySelectorAll('[data-pick-tier]').forEach(pill => pill.addEventListener('click', () => {
      const tier = form.querySelector('.pj-tier[data-tier="' + pill.dataset.pickTier + '"] input[name="quantity"]');
      if (tier) { tier.checked = true; sync(); }
      form.scrollIntoView({behavior: reduced() ? 'auto' : 'smooth', block: 'start'});
    }));
    const setBusy = state => {
      adding = state;
      [button, stickyBtn].forEach(b => { if (!b) return; b.disabled = state || !available; b.textContent = !available ? 'Agotado' : state ? 'Agregando…' : 'Agregar al carrito'; });
    };
    /* Lote elegido → una línea por acabado (2 de Plata = 1 línea × 2). Los precios de lote los aplica Shopify (descuentos automáticos). */
    const wantedItems = () => {
      const input = current();
      const qty = Math.max(1, Number(input ? input.value : 1) || 1);
      const tier = input && input.closest('.pj-tier');
      const picks = tier ? [...tier.querySelectorAll('[data-pick]')] : [];
      const ids = picks.length ? picks.map(p => Number(p.dataset.value) || finish) : Array(qty).fill(finish);
      const map = new Map();
      ids.slice(0, qty).forEach(id => map.set(id, (map.get(id) || 0) + 1));
      return [...map].map(([id, quantity]) => ({id, quantity}));
    };
    const add = async opener => {
      if (adding || !available) return;
      let items = wantedItems();
      error.hidden = true; setBusy(true);
      try {
        /* Respeta el máximo por pedido: solo se agrega lo que cabe. */
        let inCart = 0;
        try { const r = await fetch(cartPath + '.js', {headers: {'Accept': 'application/json'}, credentials: 'same-origin'}); if (r.ok) inCart = (await r.json()).item_count || 0; } catch (e) {}
        let room = MAX_QTY - inCart;
        if (room <= 0) { await openCart(opener); return; }
        items = items.map(it => { const q = Math.min(it.quantity, room); room -= q; return {id: it.id, quantity: q}; }).filter(it => it.quantity > 0);
        const response = await fetch((route.add || cartPath + '/add') + '.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items})});
        const data = await response.json();
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'No pudimos agregar la lámpara al carrito. Inténtalo de nuevo.');
        try { localStorage.setItem(TIMER_KEY, String(Date.now() + TIMER_SPAN)); } catch (e) {}
        await openCart(opener);
      } catch (issue) { error.textContent = issue.message; error.hidden = false; }
      finally { setBusy(false); }
    };
    form.addEventListener('submit', event => { event.preventDefault(); add(button); });
    if (stickyBtn) stickyBtn.addEventListener('click', () => add(stickyBtn));
    if (sticky && button && 'IntersectionObserver' in window) {
      new IntersectionObserver(entries => { const e = entries[0]; sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0; }).observe(button);
    }
    document.querySelectorAll('[data-scroll-buy]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      form.scrollIntoView({behavior: reduced() ? 'auto' : 'smooth', block: 'start'});
    }));
  }

  /* ---------- Galería ---------- */
  document.querySelectorAll('[data-gallery]').forEach(gal => {
    const track = gal.querySelector('[data-gallery-track]');
    if (!track) return;
    const slides = [...track.children];
    const thumbs = [...gal.querySelectorAll('[data-gallery-to]')];
    let index = 0;
    const activate = i => {
      index = i;
      thumbs.forEach(t => t.setAttribute('aria-current', String(Number(t.dataset.galleryTo) === i)));
      const active = thumbs[i];
      const row = gal.querySelector('[data-thumbs]');
      if (active && row) row.scrollTo({left: Math.max(0, active.offsetLeft - row.offsetLeft - row.clientWidth / 2 + active.clientWidth / 2), behavior: 'smooth'});
    };
    const go = (i, instant) => {
      index = (i + slides.length) % slides.length;
      const slide = slides[index];
      track.scrollTo({left: slide.offsetLeft - track.offsetLeft, behavior: instant || reduced() ? 'auto' : 'smooth'});
      activate(index);
    };
    gal.__go = go;
    thumbs.forEach(t => t.addEventListener('click', () => go(Number(t.dataset.galleryTo))));
    gal.querySelector('[data-gallery-next]')?.addEventListener('click', () => go(index + 1));
    gal.querySelector('[data-gallery-prev]')?.addEventListener('click', () => go(index - 1));
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        let best = 0, dist = Infinity;
        slides.forEach((s, i) => { const d = Math.abs(s.offsetLeft - track.offsetLeft - track.scrollLeft); if (d < dist) { dist = d; best = i; } });
        if (best !== index) activate(best);
      });
    }, {passive: true});
  });

  /* Llegada con ?variant= (tarjetas del inicio, líneas del carrito): la galería abre en la foto del acabado elegido,
     igual que al tocar el botón del acabado. */
  if (form && gallery && gallery.__go) {
    const pressed = form.querySelector('[data-finish][aria-pressed="true"]');
    const slides = [...gallery.querySelectorAll('[data-gallery-track] > *')];
    const i = pressed ? slides.findIndex(s => s.dataset.mediaId === String(pressed.dataset.mediaId)) : -1;
    if (i > 0) gallery.__go(i, true);
  }

  /* ---------- Preferencias de cookies ----------
     1) Si el banner de Shopify está activo: window.privacyBanner.showPreferences().
     2) Si no (banner desactivado o región sin banner): panel propio con la Customer Privacy API documentada
        (Shopify.loadFeatures consent-tracking-api → customerPrivacy.setTrackingConsent). */
  const consent = document.getElementById('pj-consent');
  const loadPrivacy = () => new Promise((resolve, reject) => {
    const S = window.Shopify;
    if (S && S.customerPrivacy) return resolve(S.customerPrivacy);
    if (!S || !S.loadFeatures) return reject(new Error('no-api'));
    S.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], err => (err ? reject(err) : resolve(S.customerPrivacy)));
  });
  if (consent && consent.showModal) {
    const consentForm = consent.querySelector('[data-consent-form]');
    const status = consent.querySelector('[data-consent-status]');
    const boxes = [...consent.querySelectorAll('[data-consent-key]')];
    let consentOpener = null;
    const say = text => { status.textContent = text; status.hidden = !text; };
    const fill = cp => {
      const allowed = {preferences: cp.preferencesProcessingAllowed(), analytics: cp.analyticsProcessingAllowed(), marketing: cp.marketingAllowed()};
      boxes.forEach(b => { b.checked = !!allowed[b.dataset.consentKey]; });
    };
    const save = async values => {
      say('');
      try {
        const cp = await loadPrivacy();
        await new Promise((resolve, reject) => cp.setTrackingConsent({preferences: values.preferences, analytics: values.analytics, marketing: values.marketing, sale_of_data: values.marketing}, r => (r && r.error ? reject(r.error) : resolve())));
        boxes.forEach(b => { b.checked = !!values[b.dataset.consentKey]; });
        say('Preferencias guardadas.');
        setTimeout(() => { if (consent.open) consent.close(); }, 1200);
      } catch (e) { say('No pudimos guardar tus preferencias. Inténtalo de nuevo.'); }
    };
    document.addEventListener('click', event => {
      const link = event.target.closest('[data-cookie-settings]');
      if (!link) return;
      event.preventDefault();
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') { window.privacyBanner.showPreferences(); return; }
      consentOpener = link; say('');
      consent.showModal();
      loadPrivacy().then(fill).catch(() => say('No pudimos cargar tus preferencias. Inténtalo de nuevo.'));
    });
    consent.querySelector('[data-consent-close]')?.addEventListener('click', () => consent.close());
    consent.addEventListener('click', event => { if (event.target === consent) consent.close(); });
    consent.addEventListener('close', () => { if (consentOpener && consentOpener.focus) consentOpener.focus(); });
    consent.querySelectorAll('[data-consent-all]').forEach(btn => btn.addEventListener('click', () => {
      const on = btn.dataset.consentAll === 'true';
      save({preferences: on, analytics: on, marketing: on});
    }));
    consentForm.addEventListener('submit', event => {
      event.preventDefault();
      const values = {};
      boxes.forEach(b => { values[b.dataset.consentKey] = b.checked; });
      save(values);
    });
  }

  /* ---------- Pie de página: columnas abiertas en escritorio ---------- */
  if (matchMedia('(min-width: 990px)').matches) document.querySelectorAll('.pj-footer-col').forEach(d => { d.open = true; });

  /* ---------- Menú móvil ---------- */
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  menuButton?.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') !== 'true';
    menuButton.setAttribute('aria-expanded', String(open));
    mobileMenu.hidden = !open;
  });

})();
